import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_SIGN_FORM_CTA_COPY = defineFcm('petition_sign_form_cta_copy')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Sign Form',
		description:
			'Kill switch for the sign form submit button CTA copy experiment (control + 4 motive-mirroring copy variants), independent of Experiment Service assignment.\n\nhttps://change.atlassian.net/browse/CHANGE-95457',
		template: {
			enabled: true,
		},
		import: false,
	});
